<template>
    <div class="sms-confirmation">
        <enter-cabinet-header />
        <!--        Вход через телефон   -->

        <div class="send-sms__wrap"
             v-if="activeTab === 'enter'"
        >
            <div class="send-sms__phone" >
                <p>
                    {{ messages && messages.phone_code_get_message }}
                     <br/> <span>{{ userPhoneNumber }}</span>
                </p>
            </div>
            <div class="send-sms__link">
                <a href="javascript:void(0)" @click.prevent="backStep">{{ messages.badNumber }}</a>
            </div>
            <form @submit.prevent="authByPhone($event)">
                <def-input
                    type="text"
                    name="code"
                    :label="messages.inputCode"
                    required
                />
<!--                <input type="text" name="code" placeholder="Ввести код из СМС" class="def-input">-->


                <p v-if="count">{{ messages.phone_code_timer }} <span>{{ count }}</span></p>
                <enter-cabiner-errors />
                <button
                    v-if="count > 0"
                    type="submit"
                    class="def-button"
                >
                    {{ messages.send_phone_code }}
                </button>
                <button v-else @click="getCodeAgain" type="button" class="def-button">
                   {{ messages && messages.resend_phone_code }}
                </button>
            </form>
            <!--            <enter-cabinet-nav-->
            <!--                :activeTab="activeTab"-->
            <!--                @changeTab="changeTab"-->

            <!--            />-->
        </div>
        <!--        Регистрация через телефон   -->
        <div class="send-sms__wrap"
             v-else-if="activeTab === 'registration'"
        >
            <div class="send-sms__phone">
                <p>
                    {{ messages && messages.phone_code_get_message }} <br/>
                    <span>{{ userPhoneNumber }}</span>
                </p>
            </div>
            <div class="send-sms__link">
                <a href="javascript:void(0)" @click.prevent="backStep">{{ messages.badNumber }}</a>
            </div>
            <form @submit.prevent="authByPhone($event)">
                <def-input
                    type="text"
                    name="code"
                    :label="messages.inputCode"
                    required
                />
                <p v-if="count">{{ messages.phone_code_timer }} <span>{{ count }}</span></p>
                <enter-cabiner-errors />

                <button
                    v-if="count > 0"
                    type="submit"
                    class="def-button"
                >
                    {{ messages.register_m }}
                </button>
                <button v-else @click="getCodeAgain" type="button" class="def-button">
                    {{ messages && authData.messages.resend_phone_code }}
                </button>
            </form>

        </div>
    </div>
</template>

<script>

    import {mapState} from 'vuex';


    export default {
        name: 'sms-confirmation',
        selector: '.sms-confirmation',
        props: ['userPhoneNumber', 'userName', 'userLastName', 'e', 'validatePhone'],
        data() {
            return {
                count: 90,
                timeOut: null,
            }
        },
        computed: {
            ...mapState({
                authData: ({ personal }) => personal.data,
                messages: ({ personal }) => personal.data.messages,
                activeTab: ({ personal }) => personal.data?.activeTab,
            }),
        },

        methods: {
            closeModal: function () {
                this.$emit('close')
            },
            async authByPhone(e) {
                try {
                    const data = new FormData(e.target);
                    const {path, data: {action, api, LANGUAGE_ID}} = this.authData?.routes?.sms_process_login;

                    data.append('action', action);
                    data.append('api', api);
                    data.append('LANGUAGE_ID', LANGUAGE_ID);
                    data.append('phone', this.userPhoneNumber);
                    data.append('authType', this.activeTab);
                    data.append('userName', this.userName);
                    // data.append('userLastName', this.userLastName);

                    const response = await axios.post(path, data);

                    if (response.status === 200 || response.statusText === 'OK') {
                        const {isAuthorize, error} = response?.data;
                        this.$store.commit('personal/updateData', {name: 'errors', data: {incorrectCode: error} });


                        if (isAuthorize) {
                            location.reload();
                        }

                    }

                } catch (err) {
                    console.error(err)
                }
            },
            backStep() {
                // this.$emit('close');
                if (!this.validatePhone) {
                    this.$DefModal.show({
                        name: 'enter-cabinet',
                        width: '440px',
                    });
                } else {
                    this.$DefModal.show({
                        name: 'validate-phone-modal',
                        width: '440px',
                    });
                }
            },
            timer() {
                this.timeOut = setTimeout(() => {
                    this.count = this.count - 1;
                    if (this.count > 0) {
                        this.timer();
                    }
                }, 1000);
            },
            async getCodeAgain() {
                const response = await this.$store.dispatch('personal/loginByPhone', { e: this.e, resend: true });

                if (response.status === 200) {
                    this.count = 90;
                    this.timer();
                }
            }
        },
        mounted() {
            this.timer();
        },
        beforeDestroy() {
            clearTimeout(this.timeOut);
        }
    }
</script>

<style lang="scss" scoped>
    .sms-confirmation {
        height: 100vh;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #53595C;
        font-size: rem(14);
        @include point-md {
            height: 100%;
        }
        &-close {
            align-self: flex-end;
            cursor: pointer;

            svg {
                fill: #85898B;
                width: 20px;
                height: 20px;
            }
        }

        &__wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &__phone {
            color: #232222;

            span {
                white-space: nowrap;
            }
        }

        &__link {
            margin-top: 16px;

            a {
                font-size: rem(14);
                line-height: 18px;
                color: #53595C;
                border-bottom: 1px dotted #53595C;
                font-family: Roboto, sans-serif;
                letter-spacing: 0.08em;
                @include point-md {
                    font-size: rem(16);
                    line-height: 20px;
                }
            }
        }

        form {
            margin-top: 24px;
            width: 100%;

            .def-input {
                width: 100%;
            }

            p {
                margin-top: 24px;
            }
        }
        .def-button{
            border: unset;
            padding: 0 20px;
            width: 100%;
            margin-top: 24px;
        }
    }
</style>